import { useEffect } from 'react'
import styles from './CustomerCases.module.css'
import { getImageUrl } from '../config'

interface HomeCaseItem {
  id: number
  name: string
  image: string
}

interface CustomerCasesProps {
  isExpanded?: boolean
  onToggle?: () => void
  onCasesClick?: () => void
  onCaseClick?: (item: HomeCaseItem) => void
  cases?: HomeCaseItem[]
}

// 预加载图片
const preloadImages = (images: string[]) => {
  images.forEach(src => {
    const img = new Image()
    img.src = src
  })
}

const CustomerCases = ({
  isExpanded = true,
  onToggle,
  onCasesClick,
  onCaseClick,
  cases = [],
}: CustomerCasesProps) => {
  // 预加载图片
  useEffect(() => {
    if (cases.length > 0) {
      const imageUrls = cases.map(c => getImageUrl(c.image))
      preloadImages(imageUrls)
    }
  }, [cases])

  const handleHeaderClick = () => {
    onToggle?.()
  }

  const handleGridItemClick = (item: HomeCaseItem) => {
    onCaseClick?.(item)
  }

  const handleMoreClick = () => {
    onCasesClick?.()
  }

  return (
    <div className={`${styles.container} ${isExpanded ? styles.expanded : ''}`}>
      <div className={styles.header} onClick={handleHeaderClick}>
        <div className={styles.headerLeft}>
          <div className={styles.iconContainer}>
            <svg viewBox="0 0 20 20" className={styles.icon}>
              <rect x="2" y="2" width="7" height="7" rx="1" fill="currentColor"/>
              <rect x="11" y="2" width="7" height="7" rx="1" fill="currentColor"/>
              <rect x="2" y="11" width="7" height="7" rx="1" fill="currentColor"/>
              <rect x="11" y="11" width="7" height="7" rx="1" fill="currentColor"/>
            </svg>
          </div>
          <div className={styles.textContainer}>
            <h3 className={styles.title}>客户案例</h3>
            <p className={styles.subtitle}>全球合作伙伴成功故事</p>
          </div>
        </div>
        <div className={`${styles.arrowContainer} ${isExpanded ? styles.expanded : ''}`}>
          <svg viewBox="0 0 24 24" className={styles.arrow}>
            <path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>

      {isExpanded && (
        <>
          <div className={styles.slider}>
            <div className={styles.grid}>
              {cases.slice(0, 6).map((item) => (
                <div key={item.id} className={styles.gridItem} onClick={() => handleGridItemClick(item)}>
                  <img src={getImageUrl(item.image)} alt={item.name} className={styles.caseImage} />
                </div>
              ))}
            </div>
          </div>
          <button type="button" className={styles.moreButton} onClick={handleMoreClick}>
            <span>查看更多</span>
          </button>
        </>
      )}
    </div>
  )
}

export default CustomerCases
